import { WorkforceReportComponent } from '../workforce/workforce-report.component';
import { SystemsReportComponent } from '../systems/systems-report.component';
import {NgModule} from "@angular/core";
import { InsightsOverviewComponent } from "./insights-overview-component";
import { MaterialModule } from "../material/material.module";
import { UIComponentsModule } from "../ui-components/ui-components.module";
import { ActionTypesComponent } from "./actions/action-types.component";
import { NodeNumbersComponent } from "./components/node-numbers.component";
import { LinqsetCardComponent } from "./components/linqset-card.component";
import { TopFiveComponent } from "./components/top-five.component";
import { FormsModule } from "@angular/forms";
import { LinqCanvasModule } from "../canvas/linq.canvas.module";
import { AllocationsTableComponent } from "./model/allocations-table.component";
import { AllocationsGraphComponent } from "./model/allocations-graph.component";
import { ChartsModule } from "../charts/charts.module";
import { InsightsComponent } from "./insights.component";
import { NodeBarComponent } from "./model-charts/node-bar.component";
import { ModelChartsComponent } from "./model-charts/model-charts.component";
import { NodeBubbleComponent } from "./model-charts/node-bubble.component";
import { NodeCapacityComponent } from "./model-charts/node-capacity.component";
import { NodeParetoComponent } from "./model-charts/node-pareto.component";
import { ContextGraphButtonComponent } from "../analysis/context-graph-button.component";
import { NodeHeatmapComponent } from "./model-charts/node-heatmap.component";
import { NodeCompareComponent } from "./model-charts/node-compare.component";
import { BaseChartDirective } from "ng2-charts";
import { BasicNodeTableComponent } from "./node-table/basic-node-table.component";
import { NodeTableComponent } from "./node-table/node-table.component";
import { NodeTypesComponent } from "./node-types/node-types.component";
import { NodeTypesInsightsComponent } from "./node-types/node-types-insights.component";
import { WarningsComponent } from "./warnings/warnings.component";
import { AnalyticsTableComponent } from "./analytics/analytics-table.component";
import { WarningsOverviewComponent } from "./warnings/warnings-overview.component";
import { ProjectDetailsComponent } from "./project/project-details.component";
import { InformationAssetTableComponent } from "./assets/information-asset-table.component";
import { ModelHeadingComponent } from "./model/model-heading.component";
import { QueryAIComponent } from "../ai/query-ai.component";
import { EPMModule } from "../epm/epm-module";

@NgModule({
	imports: [
        MaterialModule,
        UIComponentsModule,
        FormsModule,
        ChartsModule,
        BaseChartDirective,
        LinqCanvasModule,
        QueryAIComponent,
        EPMModule,
        WorkforceReportComponent,
        SystemsReportComponent,
        ContextGraphButtonComponent
	],

	declarations: [
        InsightsComponent,
        InsightsOverviewComponent,
        ActionTypesComponent,
        NodeNumbersComponent,
        LinqsetCardComponent,
        TopFiveComponent,
        AllocationsTableComponent,
        AllocationsGraphComponent,
        NodeBarComponent,
        ModelChartsComponent,
        NodeBubbleComponent,
        NodeCapacityComponent,
        NodeParetoComponent,
        NodeHeatmapComponent,
        NodeCompareComponent,
        BasicNodeTableComponent,
        NodeTableComponent,
        NodeTypesComponent,
        NodeTypesInsightsComponent,
        WarningsComponent,
        AnalyticsTableComponent,
        WarningsOverviewComponent,
        ProjectDetailsComponent,
        InformationAssetTableComponent,
        ModelHeadingComponent
	],

	exports: [
        ActionTypesComponent,
        InsightsOverviewComponent,
        InsightsComponent,
        InformationAssetTableComponent,
        NodeTableComponent,
        BasicNodeTableComponent,
        ModelChartsComponent,
        NodeTypesInsightsComponent,
        NodeBarComponent,
        TopFiveComponent,
        ModelHeadingComponent
	],

	providers: [
	]
})
export class InsightsModule {
}

